// Merge two first-player roll states, preferring locally-known fields over the
// peer's. Pure: used during reconnect/resync so a stale peer snapshot can't drag
// a player back into the dice modal after the roll already resolved locally.
export function mergeRollStates(peer, local) {
  const p = peer || {};
  const l = local || {};
  const pickNum = (a, b) => (typeof a === 'number' ? a : (typeof b === 'number' ? b : null));
  const pickSeat = (a, b) => {
    if (a === 1 || a === 2) return a;
    if (b === 1 || b === 2) return b;
    return null;
  };
  return {
    hostRoll: pickNum(l.hostRoll, p.hostRoll),
    guestRoll: pickNum(l.guestRoll, p.guestRoll),
    winnerSeat: pickSeat(l.winnerSeat, p.winnerSeat),
    firstPlayerSeat: pickSeat(l.firstPlayerSeat, p.firstPlayerSeat),
  };
}
